import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Hero } from '../sections/Hero';
import { LightSections } from '../sections/LightSections';
import { DarkSections } from '../sections/DarkSections';
export function LandingPage() {
  return <div className="min-h-screen bg-light font-sans text-navy selection:bg-techblue/20 selection:text-techblue" data-id="element-51" data-mp="1x9fm5aqm6obg">
      <Navbar data-id="element-52" data-mp="2azrhrjmer57c" />
      <main data-id="element-53" data-mp="2az9ei31bvqpx">
        <Hero data-id="element-54" data-mp="2ayzncc4jrdin" />
        <LightSections data-id="element-55" data-mp="2b2ni1elqa5yy" />
        <DarkSections data-id="element-56" data-mp="261hkn3h4huj3" />
      </main>
      <Footer data-id="element-57" data-mp="260g1ebpye1qa" />
    </div>;
}